import { QueryObject } from "ufo";

export const getRouteQuery = (): QueryObject => {
  const query: QueryObject = {};
  const searchParams =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search)
      : undefined;

  if (searchParams) {
    for (const [key, value] of searchParams.entries()) {
      if (query[key]) {
        const current = query[key];
        query[key] = Array.isArray(current)
          ? [...current, value]
          : [current, value];
      } else {
        query[key] = value;
      }
    }
  }

  return query;
};
